import { Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';

import {
  FinancialCustomerProfitabilityChartAssetsDatapointsResponseNormalized,
  FinancialCustomerProfitabilityChartDatapointEntityNormalized,
} from '../../../../../../store/customerDetail/types';

import { assetIntervalFilters } from './constants';

type BlockOfDatapoints = {
  [key: string]: FinancialCustomerProfitabilityChartDatapointEntityNormalized[];
};

export const buildChartData = (
  datapoints:
    | FinancialCustomerProfitabilityChartAssetsDatapointsResponseNormalized
    | null
    | undefined,
  currentInterval: number
) => {
  if (!datapoints) {
    return [];
  }

  const currentDatapoints = datapoints[assetIntervalFilters[currentInterval].source];
  const currentFilter = assetIntervalFilters[currentInterval];
  let compareDatapoints: BlockOfDatapoints = currentDatapoints;

  if (currentFilter.source !== 'allTimeDatapoints') {
    const maxPeriod = new Date();
    maxPeriod.setMonth(maxPeriod.getMonth() - currentFilter.lessMonths);

    compareDatapoints = Object.entries(compareDatapoints)
      .map(([key, value]) => {
        return {
          [key]: value.filter((item) => item.period && item.period >= maxPeriod),
        };
      })
      .reduce((acc, item) => ({ ...acc, ...item }), {});
  }

  const returnData: {
    internalYear: number;
    internalMonth: number;
    month: string;
    fullMonth: string;
  }[] = [];

  Object.entries(compareDatapoints).forEach(([key, value]) => {
    value.forEach((item) => {
      let found = returnData.find(
        (data) =>
          item.period &&
          data.internalYear === item.period.getFullYear() &&
          data.internalMonth === item.period.getMonth()
      );

      if (!found) {
        found = {
          month: item.monthNormalized,
          fullMonth: item.fullMonthNormalized,
          internalYear: item.period?.getFullYear() ?? 0,
          internalMonth: item.period?.getMonth() ?? 0,
        };

        returnData.push(found);
      }

      found[key] = item.percentage;
      found[`${key}P`] = Utils.Mask.Percentage(item.percentage);
    });
  });

  return returnData;
};

export const axisDefaultConfig = {
  fontFamily: Typography['fontfamily.base.regular'],
  fontSize: Typography['fontsize.sm'],
  tickLine: false,
};

export const lineDefaultConfig = {
  strokeWidth: 2,
  dot: () => <></>,
  isAnimationActive: false,
};
